import { ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Player, PlayerRegistryEntry, Team } from '../../../models/team';
import { TeamService } from '../../../services/team.service';

@Component({
  standalone: false,
  selector: 'app-team-admin',
  template: "<app-loading-overlay [show]=\"isSaving || deletingTeamIds.size > 0\"></app-loading-overlay>\n\n<details class=\"card accordion-card\" open>\n  <summary>\n    <span>Squadre</span>\n    <small>{{ teams.length }} inserite</small>\n  </summary>\n\n  <div class=\"accordion-body\">\n    <div class=\"section-actions\">\n      <button type=\"button\" (click)=\"openCreateTeamModal()\" [disabled]=\"isSaving\">Aggiungi squadra</button>\n    </div>\n\n    <p class=\"error-message\" *ngIf=\"errorMessage\">{{ errorMessage }}</p>\n    <p class=\"success-message\" *ngIf=\"successMessage\">{{ successMessage }}</p>\n    <p class=\"loading-message\" *ngIf=\"isSaving || deletingTeamIds.size\">Operazione in corso, attendere...</p>\n\n    <div class=\"team-list\">\n      <div *ngFor=\"let team of teams\" class=\"list-item\">\n        <div class=\"team-identity\">\n          <img *ngIf=\"team.logo\" [src]=\"team.logo\" [alt]=\"'Logo ' + team.name\" />\n          <div class=\"logo-fallback\" *ngIf=\"!team.logo\">{{ team.name.slice(0, 2).toUpperCase() }}</div>\n          <div class=\"item-main\">\n            <strong>{{ team.name }}</strong>\n            <span>{{ team.players_count }} giocatori</span>\n            <small *ngIf=\"team.players?.length\">{{ playerNames(team) }}</small>\n          </div>\n        </div>\n        <div class=\"list-actions\">\n          <button class=\"secondary\" (click)=\"editTeam(team)\" [disabled]=\"isSaving || isDeletingTeam(team.id)\">Modifica</button>\n          <button class=\"danger\" (click)=\"deleteTeam(team)\" [disabled]=\"isDeletingTeam(team.id)\">\n            {{ isDeletingTeam(team.id) ? 'Cancellazione...' : 'Elimina' }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</details>\n\n<div class=\"modal-backdrop\" *ngIf=\"teamModalOpen\">\n  <section class=\"modal-panel\">\n    <div class=\"modal-heading\">\n      <h2>{{ editingTeam ? 'Modifica squadra' : 'Nuova squadra' }}</h2>\n      <button type=\"button\" class=\"secondary icon-button\" (click)=\"closeTeamModal()\">Chiudi</button>\n    </div>\n\n    <form class=\"form-grid\" (submit)=\"$event.preventDefault(); saveTeam();\">\n      <label>\n        Nome squadra\n        <input type=\"text\" placeholder=\"Nome squadra\" [(ngModel)]=\"teamForm.name\" name=\"teamName\" />\n      </label>\n\n      <label>\n        Numero giocatori\n        <input type=\"number\" placeholder=\"Numero giocatori\" [(ngModel)]=\"teamForm.players_count\" name=\"teamSize\" min=\"1\" (ngModelChange)=\"onPlayersCountChange()\" />\n      </label>\n\n      <div class=\"players-editor\">\n        <strong>Giocatori da anagrafica</strong>\n        <p class=\"hint\" *ngIf=\"!registryPlayers.length\">Inserisci prima i giocatori in anagrafica o importali da file.</p>\n        <label *ngFor=\"let player of teamForm.players; let i = index; trackBy: trackPlayer\">\n          Giocatore {{ i + 1 }}\n          <div class=\"player-autocomplete\">\n            <input\n              type=\"search\"\n              autocomplete=\"off\"\n              placeholder=\"Cerca per nome, cognome o nickname\"\n              [(ngModel)]=\"playerSearchTerms[i]\"\n              [name]=\"'playerRegistrySearch' + i\"\n              (focus)=\"openPlayerSearch(i)\"\n              (ngModelChange)=\"onPlayerSearchChange(i)\"\n            />\n            <button type=\"button\" class=\"secondary clear-player-button\" *ngIf=\"player.registry_player_id\" (click)=\"clearRegistryPlayer(i)\">Rimuovi</button>\n\n            <div class=\"autocomplete-results\" *ngIf=\"activePlayerSearchIndex === i\">\n              <button\n                type=\"button\"\n                *ngFor=\"let registryPlayer of availableRegistryPlayers(i)\"\n                (mousedown)=\"$event.preventDefault()\"\n                (click)=\"selectRegistryPlayer(i, registryPlayer)\"\n              >\n                <strong>{{ registryPlayer.nickname }}</strong>\n                <span>{{ registryPlayer.last_name }} {{ registryPlayer.first_name }}<ng-container *ngIf=\"registryPlayer.jersey_number\"> - #{{ registryPlayer.jersey_number }}</ng-container></span>\n              </button>\n              <small *ngIf=\"!availableRegistryPlayers(i).length\">Nessun giocatore disponibile.</small>\n            </div>\n          </div>\n        </label>\n      </div>\n\n      <label>\n        Logo\n        <input type=\"file\" accept=\"image/*\" (change)=\"loadLogo($event)\" />\n      </label>\n\n      <div class=\"logo-preview\" *ngIf=\"teamForm.logo\">\n        <img [src]=\"teamForm.logo\" alt=\"Anteprima logo\" />\n        <button type=\"button\" class=\"secondary\" (click)=\"removeLogo()\">Rimuovi logo</button>\n      </div>\n\n      <p class=\"error-message\" *ngIf=\"errorMessage\">{{ errorMessage }}</p>\n      <p class=\"loading-message\" *ngIf=\"isSaving\">Salvataggio in corso...</p>\n\n      <div class=\"actions\">\n        <button type=\"submit\" [disabled]=\"isSaving\">{{ isSaving ? 'Salvataggio...' : (editingTeam ? 'Aggiorna squadra' : 'Aggiungi squadra') }}</button>\n        <button type=\"button\" class=\"secondary\" (click)=\"closeTeamModal()\" [disabled]=\"isSaving\">Annulla</button>\n      </div>\n    </form>\n  </section>\n</div>\n",
  styles: [".team-list {\n  display: grid;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.team-identity {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.team-identity img,\n.logo-fallback,\n.logo-preview img {\n  background: #0f172a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  height: 48px;\n  object-fit: contain;\n  width: 48px;\n}\n\n.logo-fallback {\n  align-items: center;\n  color: #b9f6c8;\n  display: flex;\n  font-weight: 800;\n  justify-content: center;\n}\n\n.logo-preview {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n}\n\n.players-editor {\n  display: grid;\n  gap: 0.7rem;\n  grid-column: 1 / -1;\n}\n\n.players-editor strong {\n  color: #e5e7eb;\n}\n\n.player-autocomplete {\n  display: grid;\n  gap: 0.4rem;\n  position: relative;\n}\n\n.clear-player-button {\n  justify-self: start;\n  padding: 0.45rem 0.65rem;\n}\n\n.autocomplete-results {\n  background: #111827;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 8px;\n  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.28);\n  display: grid;\n  gap: 0.25rem;\n  max-height: 260px;\n  overflow: auto;\n  padding: 0.45rem;\n  z-index: 5;\n}\n\n.autocomplete-results button {\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: #e5e7eb;\n  cursor: pointer;\n  display: grid;\n  gap: 0.15rem;\n  justify-items: start;\n  padding: 0.65rem;\n  text-align: left;\n  width: 100%;\n}\n\n.autocomplete-results button:hover,\n.autocomplete-results button:focus {\n  background: rgba(0, 184, 63, 0.18);\n  outline: none;\n}\n\n.autocomplete-results span {\n  color: #b9f6c8;\n  font-size: 0.85rem;\n}\n\n.autocomplete-results small {\n  color: #cbd5e1;\n  padding: 0.6rem;\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n"]
})
export class TeamAdminComponent {
  private readonly changeDetector = inject(ChangeDetectorRef);
  private readonly teamService = new TeamService();

  @Input() teams: Team[] = [];
  @Input() registryPlayers: PlayerRegistryEntry[] = [];
  @Output() changed = new EventEmitter<void>();

  teamForm: Partial<Team> = { name: '', players_count: 5, logo: null, players: this.emptyPlayers(5) };
  editingTeam: Team | null = null;
  teamModalOpen = false;
  errorMessage = '';
  successMessage = '';
  isSaving = false;
  deletingTeamIds = new Set<number>();
  playerSearchTerms: string[] = [];
  activePlayerSearchIndex: number | null = null;

  async saveTeam(): Promise<void> {
    if (this.isSaving) {
      return;
    }

    if (!this.teamForm.name || this.teamForm.name.trim() === '') {
      this.errorMessage = 'Inserisci il nome della squadra.';
      return;
    }

    if (Number(this.teamForm.players_count) < 1) {
      this.errorMessage = 'Il numero di giocatori deve essere almeno 1.';
      return;
    }
    this.syncPlayersWithCount();
    this.syncPlayerSearchTermsWithPlayers(true);
    const players = this.teamForm.players ?? [];
    const missingPlayer = players.findIndex((player) => !Number(player.registry_player_id));
    if (missingPlayer >= 0) {
      this.errorMessage = `Seleziona dall'anagrafica il giocatore ${missingPlayer + 1}.`;
      return;
    }
    const registryIds = players.map((player) => Number(player.registry_player_id));
    if (new Set(registryIds).size !== registryIds.length) {
      this.errorMessage = 'Non puoi inserire lo stesso giocatore piu volte nella stessa squadra.';
      return;
    }
    if (registryIds.some((registryPlayerId) => this.isRegistryPlayerAssignedToOtherTeam(registryPlayerId))) {
      this.errorMessage = 'Un giocatore in anagrafica non puo essere associato a piu squadre.';
      return;
    }

    try {
      this.isSaving = true;
      this.errorMessage = '';
      this.successMessage = '';
      const payload = {
        name: this.teamForm.name.trim(),
        players_count: Number(this.teamForm.players_count),
        logo: this.teamForm.logo ?? null,
        players: players.map((player) => ({
          id: player.id,
          registry_player_id: Number(player.registry_player_id)
        }))
      };

      if (this.editingTeam) {
        await this.teamService.update(this.editingTeam.id, payload);
      } else {
        await this.teamService.create(payload);
      }

      this.teamModalOpen = false;
      this.successMessage = 'Operazione conclusa. Squadra salvata.';
      this.resetTeamForm();
      this.changed.emit();
      this.changeDetector.detectChanges();
    } catch (error) {
      this.successMessage = '';
      this.errorMessage = this.readError(error, 'Errore durante il salvataggio della squadra.');
      this.changeDetector.detectChanges();
    } finally {
      this.isSaving = false;
      this.changeDetector.detectChanges();
    }
  }

  editTeam(team: Team): void {
    this.editingTeam = team;
    this.teamForm = {
      name: team.name,
      players_count: team.players_count,
      logo: team.logo,
      players: this.playersForForm(team)
    };
    this.syncPlayersWithCount();
    this.syncPlayerSearchTermsWithPlayers(true);
    this.teamModalOpen = true;
    this.successMessage = '';
    this.changeDetector.detectChanges();
  }

  async deleteTeam(team: Team): Promise<void> {
    if (this.deletingTeamIds.has(team.id)) {
      return;
    }

    if (!window.confirm(`Confermi la cancellazione della squadra "${team.name}"?`)) {
      return;
    }

    try {
      this.deletingTeamIds.add(team.id);
      this.errorMessage = '';
      this.successMessage = '';
      await this.teamService.delete(team.id);
      this.resetTeamForm();
      this.teams = this.teams.filter((item) => item.id !== team.id);
      this.successMessage = 'Operazione conclusa. Squadra cancellata.';
      this.changed.emit();
      this.changeDetector.detectChanges();
    } catch (error) {
      this.successMessage = '';
      this.errorMessage = this.readError(error, 'Errore durante la cancellazione della squadra.');
      this.changeDetector.detectChanges();
    } finally {
      this.deletingTeamIds.delete(team.id);
      this.changeDetector.detectChanges();
    }
  }

  resetTeamForm(): void {
    this.editingTeam = null;
    this.teamForm = { name: '', players_count: 5, logo: null, players: this.emptyPlayers(5) };
    this.playerSearchTerms = this.emptyPlayerSearchTerms(5);
    this.activePlayerSearchIndex = null;
    this.errorMessage = '';
    this.changeDetector.detectChanges();
  }

  onPlayersCountChange(): void {
    this.syncPlayersWithCount();
    this.syncPlayerSearchTermsWithPlayers(false);
    this.changeDetector.detectChanges();
  }

  openCreateTeamModal(): void {
    this.resetTeamForm();
    this.teamModalOpen = true;
    this.successMessage = '';
    this.changeDetector.detectChanges();
  }

  closeTeamModal(): void {
    this.teamModalOpen = false;
    this.resetTeamForm();
  }

  async loadLogo(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    try {
      this.errorMessage = '';
      this.teamForm.logo = await this.optimizedLogoDataUrl(file);
      this.changeDetector.detectChanges();
    } catch (error) {
      this.errorMessage = this.readError(error, 'Errore durante il caricamento del logo.');
      this.changeDetector.detectChanges();
    }
  }

  removeLogo(): void {
    this.teamForm.logo = null;
    this.changeDetector.detectChanges();
  }

  trackPlayer(index: number): number {
    return index;
  }

  playerNames(team: Team): string {
    return (team.players ?? []).map((player) => this.playerLabel(player)).join(', ');
  }

  registryPlayerLabel(player: PlayerRegistryEntry): string {
    const jerseyNumber = player.jersey_number ? ` #${player.jersey_number}` : '';
    return `${player.last_name} ${player.first_name} (${player.nickname})${jerseyNumber} - ${player.role}`;
  }

  availableRegistryPlayers(index: number): PlayerRegistryEntry[] {
    const query = this.normalizedSearch(this.playerSearchTerms[index] ?? '');
    return this.registryPlayers
      .filter((registryPlayer) => {
        const selectedForCurrentSlot = Number(this.teamForm.players?.[index]?.registry_player_id) === registryPlayer.id;
        if (!selectedForCurrentSlot && this.isRegistryPlayerUnavailable(registryPlayer.id, index)) {
          return false;
        }
        if (!query) {
          return true;
        }
        return this.normalizedSearch(this.registryPlayerLabel(registryPlayer)).includes(query);
      })
      .slice(0, 10);
  }

  openPlayerSearch(index: number): void {
    this.activePlayerSearchIndex = index;
    this.changeDetector.detectChanges();
  }

  onPlayerSearchChange(index: number): void {
    const player = this.teamForm.players?.[index];
    if (!player) {
      return;
    }

    const selectedPlayer = this.registryPlayers.find((item) => item.id === Number(player.registry_player_id));
    if (selectedPlayer && this.normalizedSearch(this.playerSearchTerms[index]) !== this.normalizedSearch(this.registryPlayerLabel(selectedPlayer))) {
      player.registry_player_id = 0;
    }

    this.activePlayerSearchIndex = index;
    this.changeDetector.detectChanges();
  }

  selectRegistryPlayer(index: number, registryPlayer: PlayerRegistryEntry): void {
    const player = this.teamForm.players?.[index];
    if (!player) {
      return;
    }

    player.registry_player_id = registryPlayer.id;
    player.name = registryPlayer.nickname;
    player.first_name = registryPlayer.first_name;
    player.last_name = registryPlayer.last_name;
    player.nickname = registryPlayer.nickname;
    player.jersey_number = registryPlayer.jersey_number;
    player.role = registryPlayer.role;
    this.playerSearchTerms[index] = this.registryPlayerLabel(registryPlayer);
    this.activePlayerSearchIndex = null;
    this.errorMessage = '';
    this.changeDetector.detectChanges();
  }

  clearRegistryPlayer(index: number): void {
    const player = this.teamForm.players?.[index];
    if (!player) {
      return;
    }

    player.registry_player_id = 0;
    player.name = '';
    player.first_name = undefined;
    player.last_name = undefined;
    player.nickname = undefined;
    player.jersey_number = null;
    player.role = null;
    this.playerSearchTerms[index] = '';
    this.activePlayerSearchIndex = index;
    this.changeDetector.detectChanges();
  }

  playerLabel(player: Player): string {
    const fullName = [player.last_name, player.first_name].filter(Boolean).join(' ').trim();
    const nickname = player.nickname || player.name;
    const jerseyNumber = player.jersey_number ? ` #${player.jersey_number}` : '';
    return fullName ? `${fullName} (${nickname})${jerseyNumber}` : `${nickname}${jerseyNumber}`;
  }

  isRegistryPlayerSelected(registryPlayerId: number, currentIndex: number): boolean {
    return (this.teamForm.players ?? []).some((player, index) => index !== currentIndex && Number(player.registry_player_id) === Number(registryPlayerId));
  }

  isRegistryPlayerUnavailable(registryPlayerId: number, currentIndex: number): boolean {
    return this.isRegistryPlayerSelected(registryPlayerId, currentIndex) || this.isRegistryPlayerAssignedToOtherTeam(registryPlayerId);
  }

  isDeletingTeam(teamId: number): boolean {
    return this.deletingTeamIds.has(teamId);
  }

  private syncPlayersWithCount(): void {
    const count = Math.max(1, Number(this.teamForm.players_count || 1));
    this.teamForm.players_count = count;
    const players = [...(this.teamForm.players ?? [])];

    while (players.length < count) {
      players.push({ name: '', registry_player_id: 0 });
    }
    if (players.length > count) {
      players.length = count;
    }

    this.teamForm.players = players;
  }

  private emptyPlayers(count: number): Player[] {
    return Array.from({ length: count }, () => ({ name: '', registry_player_id: 0 }));
  }

  private emptyPlayerSearchTerms(count: number): string[] {
    return Array.from({ length: count }, () => '');
  }

  private playersForForm(team: Team): Player[] {
    const players: Player[] = team.players?.length ? team.players.map((player) => ({
      id: player.id,
      name: player.name,
      registry_player_id: player.registry_player_id ?? 0,
      first_name: player.first_name,
      last_name: player.last_name,
      nickname: player.nickname,
      jersey_number: player.jersey_number,
      role: player.role,
      age: player.age,
      phone: player.phone,
      email: player.email
    })) : [];
    while (players.length < team.players_count) {
      players.push({ name: '', registry_player_id: 0 });
    }
    return players.slice(0, team.players_count);
  }

  private readError(error: unknown, fallback: string): string {
    return error instanceof Error ? error.message : fallback;
  }

  private async optimizedLogoDataUrl(file: File): Promise<string> {
    const original = await this.readFileAsDataUrl(file);
    if (file.size <= 700_000) {
      return original;
    }

    try {
      const image = await this.loadImage(original);
      const maxSide = 900;
      const scale = Math.min(1, maxSide / Math.max(image.width, image.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.width * scale));
      canvas.height = Math.max(1, Math.round(image.height * scale));

      const context = canvas.getContext('2d');
      if (!context) {
        return original;
      }

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);

      let quality = 0.84;
      let dataUrl = canvas.toDataURL('image/jpeg', quality);
      while (dataUrl.length > 900_000 && quality > 0.54) {
        quality -= 0.1;
        dataUrl = canvas.toDataURL('image/jpeg', quality);
      }

      return dataUrl.length < original.length ? dataUrl : original;
    } catch (_error) {
      return original;
    }
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error('Logo non leggibile'));
      reader.readAsDataURL(file);
    });
  }

  private loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('Logo non valido'));
      image.src = src;
    });
  }

  private syncPlayerSearchTermsWithPlayers(forceSelectedLabels: boolean): void {
    const players = this.teamForm.players ?? [];
    while (this.playerSearchTerms.length < players.length) {
      this.playerSearchTerms.push('');
    }
    if (this.playerSearchTerms.length > players.length) {
      this.playerSearchTerms.length = players.length;
    }

    players.forEach((player, index) => {
      const registryPlayer = this.registryPlayers.find((item) => item.id === Number(player.registry_player_id));
      if (registryPlayer && (forceSelectedLabels || !this.playerSearchTerms[index])) {
        this.playerSearchTerms[index] = this.registryPlayerLabel(registryPlayer);
      }
      if (!registryPlayer && forceSelectedLabels) {
        this.playerSearchTerms[index] = '';
      }
    });
  }

  private normalizedSearch(value: string | null | undefined): string {
    return (value ?? '').trim().toLocaleLowerCase('it-IT');
  }

  private isRegistryPlayerAssignedToOtherTeam(registryPlayerId: number): boolean {
    return this.teams.some((team) => {
      if (this.editingTeam && team.id === this.editingTeam.id) {
        return false;
      }
      return (team.players ?? []).some((player) => Number(player.registry_player_id) === Number(registryPlayerId));
    });
  }
}
